import { apiRequest } from "../../index";

export const addRestaurant = async (restaurantData) => {
  return apiRequest("/api/owner/restaurant", "POST", restaurantData, true);
};

export const getAllRestaurants = async ({ page, limit }) => {
  return apiRequest(`/api/owner/restaurant?page=${page}&limit=${limit}`, "GET");
};

export const getRestaurantById = async (restaurantId) => {
  return apiRequest(`/api/owner/restaurant/${restaurantId}`, "GET");
};

export const updateRestaurant = async (restaurantId, restaurantData) => {
  return apiRequest(`/api/owner/restaurant/${restaurantId}`, "PUT", restaurantData, true);
};

export const deleteRestaurant = async (restaurantId) => {
  return apiRequest(`/api/owner/restaurant/${restaurantId}`, "DELETE");
};

export const getAllRestaurantsWithoutPagination = async () => {
  return apiRequest(`/api/owner/restaurant/listing/names`, "GET");
};

export const updateTableBookings = async (data) => {
  return apiRequest(`/api/owner/restaurant/table-bookings/${data.restaurantId}`, "PUT", data);
};